export const aboutTranslations = {
    en: {
        pageTitle: "About Gagandeep Singh & Associates",
        pageSubtitle: "Investigation Legacy + Insurance Risk Verification Expansion",
        leadText: "<strong>Gagandeep Singh & Associates</strong> is a Punjab–Haryana-focused insurance investigation, police liaison, and risk-verification firm supporting insurers in fraud detection and claim validation.",
        description: "Founded and led by <strong>Gagandeep Singh</strong>, the firm combines field investigation, police coordination, statutory record procurement, and technical analysis to produce defensible claim conclusions.",
        evolution: {
            title: "Evolution",
            items: [
                {
                    year: "Since 2007",
                    title: "Insurance Investigation & Police Liaison",
                    desc: "Established foundation in motor insurance investigations and law enforcement coordination"
                },
                {
                    year: "Since Aug 2022",
                    title: "IBNR & FFRM Risk Verification Projects",
                    desc: "Expanded services to include proactive risk detection and portfolio-level verification"
                }
            ]
        },
        strength: {
            title: "Operational Strength",
            cards: [
                {
                    title: "20-member backend team",
                    desc: "Documentation & coordination specialists"
                },
                {
                    title: "Dedicated field officer network",
                    desc: "Experienced investigation professionals"
                },
                {
                    title: "Mohali HQ with regional coverage",
                    desc: "Strategic location for Punjab & Haryana operations"
                }
            ]
        },
        values: {
            title: "Core Values",
            items: ["Accuracy", "Integrity", "Compliance", "Confidentiality", "Professional Liaison"]
        },
        leader: {
            name: "Gagandeep Singh",
            title: "Principal Investigator",
            company: "Gagandeep Singh & Associates",
            quote: "\"Investigating with diligence, delivering with integrity.\""
        }
    },
    hi: {
        pageTitle: "गगनदीप सिंह एंड एसोसिएट्स के बारे में",
        pageSubtitle: "जांच विरासत + बीमा जोखिम सत्यापन विस्तार",
        leadText: "<strong>गगनदीप सिंह एंड एसोसिएट्स</strong> पंजाब-हरियाणा-केंद्रित बीमा जांच, पुलिस संपर्क और जोखिम-सत्यापन फर्म है जो धोखाधड़ी का पता लगाने और दावा सत्यापन में बीमाकर्ताओं का समर्थन करती है।",
        description: "<strong>गगनदीप सिंह</strong> द्वारा स्थापित और नेतृत्व में, फर्म रक्षात्मक दावा निष्कर्ष निकालने के लिए क्षेत्र जांच, पुलिस समन्वय, वैधानिक रिकॉर्ड खरीद और तकनीकी विश्लेषण को जोड़ती है।",
        evolution: {
            title: "विकास",
            items: [
                {
                    year: "2007 से",
                    title: "बीमा जांच और पुलिस संपर्क",
                    desc: "मोटर बीमा जांच और कानून प्रवर्तन समन्वय में स्थापित नींव"
                },
                {
                    year: "अगस्त 2022 से",
                    title: "IBNR और FFRM जोखिम सत्यापन परियोजनाएं",
                    desc: "सक्रिय जोखिम का पता लगाने और पोर्टफोलियो-स्तरीय सत्यापन को शामिल करने के लिए विस्तारित सेवाएं"
                }
            ]
        },
        strength: {
            title: "परिचालन शक्ति",
            cards: [
                {
                    title: "20-सदस्यीय बैकएंड टीम",
                    desc: "दस्तावेज़ीकरण और समन्वय विशेषज्ञ"
                },
                {
                    title: "समर्पित फील्ड अधिकारी नेटवर्क",
                    desc: "अनुभवी जांच पेशेवर"
                },
                {
                    title: "क्षेत्रीय कवरेज के साथ मोहाली मुख्यालय",
                    desc: "पंजाब और हरियाणा संचालन के लिए रणनीतिक स्थान"
                }
            ]
        },
        values: {
            title: "मूल्य",
            items: ["सटीकता", "अखंडता", "अनुपालन", "गोपनीयता", "पेशेवर संपर्क"]
        },
        leader: {
            name: "गगनदीप सिंह",
            title: "प्रधान अन्वेषक",
            company: "गगनदीप सिंह एंड एसोसिएट्स",
            quote: "\"परिश्रम के साथ जांच, ईमानदारी के साथ वितरण।\""
        }
    },
    pa: {
        pageTitle: "ਗਗਨਦੀਪ ਸਿੰਘ ਐਂਡ ਐਸੋਸੀਏਟਸ ਬਾਰੇ",
        pageSubtitle: "ਜਾਂਚ ਵਿਰਾਸਤ + ਬੀਮਾ ਜੋਖਮ ਤਸਦੀਕ ਵਿਸਤਾਰ",
        leadText: "<strong>ਗਗਨਦੀਪ ਸਿੰਘ ਐਂਡ ਐਸੋਸੀਏਟਸ</strong> ਇੱਕ ਪੰਜਾਬ-ਹਰਿਆਣਾ-ਕੇਂਸਤ੍ਰਿਤ ਬੀਮਾ ਜਾਂਚ, ਪੁਲਿਸ ਤਾਲਮੇਲ, ਅਤੇ ਜੋਖਮ-ਪ੍ਰਮਾਣਿਕਤਾ ਫਰਮ ਹੈ ਜੋ ਧੋਖਾਧੜੀ ਦਾ ਪਤਾ ਲਗਾਉਣ ਅਤੇ ਦਾਅਲੇ ਦੀ ਪ੍ਰਮਾਣਿਕਤਾ ਵਿੱਚ ਬੀਮਾਕਰਤਾਵਾਂ ਦਾ ਸਮਰਥਨ ਕਰਦੀ ਹੈ।",
        description: "<strong>ਗਗਨਦੀਪ ਸਿੰਘ</strong> ਦੁਆਰਾ ਸਥਾਪਿਤ ਅਤੇ ਅਗਵਾਈ ਵਾਲੀ, ਫਰਮ ਬਚਾਅ ਪੱਖੀ ਦਾਅਲੇ ਦੇ ਸਿੱਟੇ ਕੱਢਣ ਲਈ ਖੇਤਰੀ ਜਾਂਚ, ਪੁਲਿਸ ਤਾਲਮੇਲ, ਕਾਨੂੰਨੀ ਰਿਕਾਰਡ ਦੀ ਖਰੀਦ, ਅਤੇ ਤਕਨੀਕੀ ਵਿਸ਼ਲੇਸ਼ਣ ਨੂੰ ਜੋੜਦੀ ਹੈ।",
        evolution: {
            title: "ਵਿਕਾਸ",
            items: [
                {
                    year: "2007 ਤੋਂ",
                    title: "ਬੀਮਾ ਜਾਂਚ ਅਤੇ ਪੁਲਿਸ ਤਾਲਮੇਲ",
                    desc: "ਮੋਟਰ ਬੀਮਾ ਜਾਂਚ ਅਤੇ ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੇ ਤਾਲਮੇਲ ਵਿੱਚ ਸਥਾਪਤ ਨੀਂਹ"
                },
                {
                    year: "ਅਗਸਤ 2022 ਤੋਂ",
                    title: "IBNR ਅਤੇ FFRM ਜੋਖਮ ਤਸਦੀਕ ਪ੍ਰੋਜੈਕਟ",
                    desc: "ਕਿਰਿਆਸ਼ੀਲ ਜੋਖਮ ਖੋਜ ਅਤੇ ਪੋਰਟਫੋਲੀਓ-ਪੱਧਰ ਦੀ ਤਸਦੀਕ ਨੂੰ ਸ਼ਾਮਲ ਕਰਨ ਲਈ ਵਿਸਤ੍ਰਿਤ ਸੇਵਾਵਾਂ"
                }
            ]
        },
        strength: {
            title: "ਸੰਚਾਲਨ ਸ਼ਕਤੀ",
            cards: [
                {
                    title: "20-ਮੈਂਬਰੀ ਬੈਕਐਂਡ ਟੀਮ",
                    desc: "ਦਸਤਾਵੇਜ਼ ਅਤੇ ਤਾਲਮੇਲ ਮਾਹਰ"
                },
                {
                    title: "ਸਮਰਪਿਤ ਫੀਲਡ ਅਫਸਰ ਨੈਟਵਰਕ",
                    desc: "ਤਜਰਬੇਕਾਰ ਜਾਂਚ ਪੇਸ਼ੇਵਰ"
                },
                {
                    title: "ਖੇਤਰੀ ਕਵਰੇਜ ਦੇ ਨਾਲ ਮੋਹਾਲੀ ਹੈੱਡਕੁਆਰਟਰ",
                    desc: "ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਦੇ ਸੰਚਾਲਨ ਲਈ ਰਣਨੀਤਕ ਸਥਾਨ"
                }
            ]
        },
        values: {
            title: "ਮੂਲ ਮੁੱਲ",
            items: ["ਸ਼ੁੱਧਤਾ", "ਇਮਾਨਦਾਰੀ", "ਪਾਲਣਾ", "ਗੁਪਤਤਾ", "ਪੇਸ਼ੇਵਰ ਤਾਲਮੇਲ"]
        },
        leader: {
            name: "ਗਗਨਦੀਪ ਸਿੰਘ",
            title: "ਪ੍ਰਿੰਸੀਪਲ ਇਨਵੈਸਟੀਗੇਟਰ",
            company: "ਗਗਨਦੀਪ ਸਿੰਘ ਐਂਡ ਐਸੋਸੀਏਟਸ",
            quote: "\"ਮਿਹਨਤ ਨਾਲ ਜਾਂਚ, ਇਮਾਨਦਾਰੀ ਨਾਲ ਸਪੁਰਦਗੀ।\""
        }
    }
};
